import { IUpdateGestaoRecebimentoEpiUseCase } from "../../../presentation/useCases/update/update_gestao_recebimento_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class UpdateGestaoRecebimentoEpiUseCase implements IUpdateGestaoRecebimentoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async updateGestaoRecebimentoEpi(
    idGestaoRecebimentoEpi: number,
    idGestaoEpi: number,
    idFornecedor: number | null,
    ca: string | null,
    quantidade: number | null,
    dataRecebimento: Date | null,
    dataValidade: Date | null,
    idCentroCusto: number | null,
    marca: string | null,
    notaFiscal: string | null,
    limparArquivoNotaFiscal?: boolean | null,
    arquivoNotaFiscal?: File | null,
    valorUnitario?: number | null,
    valorTotal?: number | null,
  ): Promise<void> {
    await this.repository.updateGestaoRecebimentoEpi(
      idGestaoRecebimentoEpi,
      idGestaoEpi,
      idFornecedor,
      ca,
      quantidade,
      dataRecebimento,
      dataValidade,
      idCentroCusto,
      marca,
      notaFiscal,
      limparArquivoNotaFiscal,
      arquivoNotaFiscal,
      valorUnitario,
      valorTotal
    );
  }
}
